import { MANUFACTURER_GROUP_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Manufacturer Group Id",
    field: "manufacturerGroupId",
    width: 200,
  },
  {
    headerName: "Manufacturer Group",
    field: "name",
    width: 300,
  },
  {
    headerName: "Manufacturers Name",
    field: "manufacturers",
    width: 800,
  },
];

export const transformPayload = (manufacturer) => {
  return {
    manufacturerGroupId: manufacturer?.manufacturerGroupId,
    name: manufacturer?.name,
    manufacturerIds: manufacturer?.manufacturers || [],
  };
};
export const columnDefsFunctions = {
  manufacturers: {
    valueGetter: (params) => {
      const manufacturers = params.data.manufacturers;
      if (!Array.isArray(manufacturers) || manufacturers.length === 0) {
        return "";
      }
      return manufacturers
        .map((manufacturer) => manufacturer.manufacturerName)
        .join(",");
    },
  },
};

export const initial_state_manufacturer_group = {
  type: MANUFACTURER_GROUP_TAB,
  label: "Manufacturer Group Master",
  allowMultipleTabs: false,
};
